import type { Messages } from '../catalogue.en'

export const clinicalTranslation: Partial<Messages> = {
  'record.translate': 'תרגום',
  'record.translationLanguageMenu': 'שפת התרגום',
  'record.translationLanguageTabs': 'השפה המוצגת',
  'record.translationLanguageField': 'השפה המוצגת בשדה הזה',
  'record.translationSavedMark': 'נשמר',
  'record.translationBadge': 'לשדה זה קיים תרגום',
  'record.translationTitle': 'תרגום הרשומה הקלינית',
  'record.translationTranslating': 'מתבצע תרגום…',
  'record.translationDiscard': 'ביטול השינויים',
  'record.translationSourceDirty': 'יש לשמור את הפרוטוקול לפני תרגום; כפתור השמירה שומר את הפרוטוקול והתרגום יחד.',
  'record.translationSwitchBlocked': 'יש לשמור או לבטל את התרגום הזה לפני החלפת השפה.',
  'record.translationStale': 'רשומת המקור השתנתה לאחר שמירת התרגום.',
  'record.translationEmpty': 'ברשומה אין טקסט שאינו ריק לתרגום.',
  'record.translationLoadFailed': 'לא ניתן לטעון את התרגומים השמורים.',
  'record.translationGenerateFailed': 'לא ניתן היה להכין את התרגום. יש לנסות שוב.',
  'record.translationKeyMissing': 'יש להוסיף מפתח OpenAI בהגדרות החשבון לפני התרגום.',
  'record.translationSourceChanged': 'רשומת המקור השתנתה. יש לטעון אותה מחדש לפני תרגום נוסף.',
  'record.translationSaveFailed': 'לא ניתן לשמור את התרגום. יש לנסות שוב.',
  'record.translationSaveConflict': 'התרגום או רשומת המקור השתנו במקום אחר. יש לטעון מחדש לפני השמירה.',
  'record.translationReplaceTitle': 'החלפת טקסט התרגום',
  'record.translationReplaceBody': 'תרגום AI חדש יחליף את טקסט התרגום המוצג כעת.',
  'record.translationReplaceConfirm': 'החלפה בתרגום חדש',
  'record.translationReplaceCancel': 'השארת הטקסט הנוכחי',
  'record.translationUnsavedIntent': 'תרגום רשומה קלינית — שינויים שלא נשמרו',
}
